var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"}},[_c('v-alert',{attrs:{"dense":"","outlined":"","dismissible":"","type":"error","value":true},on:{"click":function($event){return _vm.onClose()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }